// extracted by mini-css-extract-plugin
export default {"headline":"grandprix__headline__3Wfqv","title":"grandprix__title__2Dx1B","demo-link":"grandprix__demo-link__1fHRn","demoLink":"grandprix__demo-link__1fHRn"};